import { atom } from "jotai";

export const verificationTokenAtom = atom<string | null>(null);
